import vSelect from "vue-select";
import stickDropdownToSelect from '$utils/stickDropdownToSelect';

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},

	components: {
		"v-select": vSelect,
	},

	data() {
		return {
			localValue: null,
		};
	},

	watch: {
		'context._value': {
			handler(newVal) {
				this.localValue = newVal;
			},
			immediate: true,
			deep: true,
		},
	},

	computed: {
		selectedOptions: {
			get() {
				const values = this.localValue;
				if (!values || !Array.isArray(values)) return [];
				const options = this.context.attrs.options || [];
				return options.filter(opt => values.includes(opt.value));
			}
		},
		emptyMessage: {
			get() {
				return this.context.attrs?.emptyMessage ? this.context.attrs.emptyMessage : 'Er zijn geen opties beschikbaar.';
			}
		}
	},

	methods: {
		calculateSelectPosition(dropdownList, component, { width }) {
			stickDropdownToSelect(dropdownList, component, { width });
		},
		handleInput(value) {
			if (this.context.node && typeof this.context.node.input === 'function') {
				this.context.node.input(value);
			} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
				this.context.handlers.input(value);
			}
		},
		onClose: function () {
			if (this.context.handlers?.blur) {
				this.context.handlers.blur();
			} else if (this.context.blurHandler) {
				this.context.blurHandler();
			}
		},

		onOpen() {
			// window.setTimeout(() => {
			// 	debugger;
			// }, 3000);
		},

		onOptionClick(option) {
			const currentValue = this.context._value || [];
			const index = currentValue.indexOf(option.value);
			if (index > -1) {
				const newValue = [...currentValue];
				newValue.splice(index, 1);
				if (this.context.node && typeof this.context.node.input === 'function') {
					this.context.node.input(newValue);
				}
			}
		}
	},
};
